import { countryCodes } from "../../../common/data/countryCodes";
import { isPhoneNumberStub } from "../../../utils/phoneNumber";

export type ParsedPhoneNumber = {
  countryCode: string | null;
  mobile: string;
};

// userData.phonenumber is stored as "<prefix digits> <national number>"
// (e.g. "357 68999999" for a Cypriot number). Splits that into the matching
// countryCodes entry and the bare national number for the form fields.
export function parsePhoneNumber(
  phone: string | null | undefined,
): ParsedPhoneNumber | null {
  if (!phone) return null;

  const trimmed = phone.trim();
  if (!trimmed || isPhoneNumberStub(trimmed)) return null;

  const spaceIndex = trimmed.indexOf(" ");
  if (spaceIndex === -1) {
    // No country code stored — treat as a plain national number.
    return { countryCode: null, mobile: trimmed.replace(/\D/g, "") };
  }

  const prefixPart = trimmed.slice(0, spaceIndex);
  const numberPart = trimmed.slice(spaceIndex + 1).replace(/\D/g, "");
  const match = countryCodes.find((o) => o.prefix === prefixPart);

  return {
    countryCode: `+${match?.prefix ?? prefixPart}`,
    mobile: numberPart,
  };
}
